<template>
  <div>
    <v-container class="mt-3">
      <v-layout row justify-center mt-5 pb-5>
        <v-flex xs12 md8>
          <v-card class="defaultCardClass" flat>
            <v-card-title class="text-center pt-6 pb-0 px-6 justify-center align-center">
              <v-text-field
                v-model="name"
                :label="$t('labels.names')"
                outlined
                rounded
              >
                <template v-slot:append>
                  <v-btn
                    text
                    :disabled="name.length < 3"
                    color="primary"
                    @click="getContent"
                    class="text-capitalize"
                    style="margin-top:-7px"
                  >
                    {{$t('buttons.search')}}
                  </v-btn>
                </template>
              </v-text-field>
            </v-card-title>

            <v-card-title class="pt-0 pb-0 px-0">
              <loading-progress :status="loadingList" />
              <v-list
                subheader
                two-line
                style="
                  background-color: transparent !important;
                  width: 100%;
                  overflow-y: scroll;
                  height: calc(100vh - 260px);
                "
              >
                <div
                  v-for="(item, index) in data"
                  :key="item.Id.concat(index.toString())"
                >
                  <user-list-item
                    :item="item"
                    :avatar="item.Avatar"
                    :fullName="item.FullName"
                    :department="item.Department"
                    :userId="item.Id"
                    :company="item.Company"
                    :noBg="true"
                    :divider="data.length == index + 1 ? false : true"
                  />
                </div>
              </v-list>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ContentService from "@/services/ContentService";
import UserListItem from "../../components/Users/UserListItem.vue";
import LoadingProgress from "../../components/General/LoadingProgress.vue";

export default {
  data: function () {
    {
      return {
        data: [],
        loadingList: false,
        name: "",
      };
    }
  },
  components: {
    UserListItem,
    LoadingProgress,
  },
  methods: {
    getContent() {
      this.loadingList = true;
      ContentService.getWhosWho(this.name)
        .then((res) => {
          this.data = res.data;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.loadingList = false;
        });
    },
  },
  computed: {},
  destroyed() {},
  mounted() {
    //this.getContent();
  },
  watch: {},
};
</script>
